import MiningOperationsMap from './MiningOperationsMap';

export default MiningOperationsMap;